import { useQuery } from '@apollo/client';
import config from 'config';
import { cache } from 'graph_ql';
import { SEARCH_STYLE, SEARCH_STYLE_TYPE } from 'graph_ql/search/search_style';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import utils from 'utils/utils';
import { buildStoreFilter } from '../utils/getQuerySearchStyles';

export const useDiscoverYourStyles = () => {
    const store = useSelector((state: RootState) => state.widget.store);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const userGender = utils.getFormattedGender(me?.gender);
    const discoverStyleSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = `status: published`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(store)})`;
        }
        if (userGender) {
            filters += ` AND genders.value: ${userGender}`;
        }
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_discover_styles,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            page: 0,
            facets: [],
        };
    }, [store, userGender]);
    const { loading, data } = useQuery(SEARCH_STYLE, {
        variables: discoverStyleSearchVariables,
        fetchPolicy: 'cache-first',
    });

    const listStyles = useMemo(() => {
        return data?.locationsInRadius?.hits || [];
    }, [data]);

    return { loading, listStyles };
};
